import Api from "@/services/Index";
import financeApi from "@/services/FinanceApi";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/job/logs", config);
};

const getMyLogs = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/job/logs/me", config);
};

const get = async (logId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/job/logs/" + logId);
};

const download = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/job/logs/download/" + id, null, {
        responseType: "arraybuffer",
    });
};

const downloadFailLog = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/job/logs/download-fail-log/" + id, {
        responseType: "arraybuffer",
    });
};

const calculateExtraGraduateCourses = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/extra/graduation/courses/calculate");
};

const autoCourseRegistration = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/course/registration/auto-course-registration", config);
};

const autoRepeatCourseRegistration = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(
        "/course/registration/auto-repeat-course-registration",
        config
    );
};

const autoIrregularCourseRegistration = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/course/registration/auto-irregular-course-registration",
        config
    );
};

const createStudentSemesters = async (semesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/semesters/create/" + semesterId);
};

const assignDoesntHavePaymentApproval = async (semesterId, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/semesters/assign-doesnt-have-payment-approval/" + semesterId, formData);
};

const assignDoesntHaveCourseRegistration = async (semesterId, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/semesters/assign-doesnt-have-course-registration/" + semesterId, formData);
};

const prepStudentsSemesterStatusUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/prep/students/update-semester-statuses/", formData);
};
const bulkAddressUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/students/bulk-update-contact-information-from-kps", formData);
};
const foreignStudentCommunityInternshipAssignment = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/course/registration/auto-internship-course-registration", formData);
};

const registrationsBulkDelete = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/registrations/bulk-delete", formData, {responseType: 'arraybuffer'});
};
const courseDropCommand = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/course/registration/not-confirmation-courses-delete");
};
const fileImport = async (file) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/students/excel-import', file);
}
const studentExcelImport = async (file) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/students/class/excel-import', file);
}
const bulkTranslationImport = async (file) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/translations/excel-import', file);
}

const updateSummerSchoolPaidStatus = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/courses/update-summer-school-paid-status', formData);
}

const studentProgramsGraduationRequirement = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/programs/graduation-requirement/excel-import', formData);
}

const deleteEmptySummerStudentSemester = async (semesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/semesters/delete-empty-summer-student-semester/" + semesterId);
}

const createSectionForRepeats = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/thesis/and/projects/create-section-for-repeats");
};

const scholarshipsImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_FINANCE;
    return Api.post("/scholarships/import", formData);
};

const registrationsImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/registrations/import", formData);
};

const updateMaxDurationInformationStart = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/programs/max-duration-information-for-advisor', formData);
}

const findPersonFromKpsByStudentNumbers = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/students/kps-job', formData);
}

const osymScoreInquiry = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/osym/service/osym-point-excel-export', formData);
}

const queryOsymPoints = (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/osym/service/query-osym-points', formData);
}

const calculateNumberOfSemesters = (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/programs/calculate-number-of-semesters-job', config);
}

const preparatoryClassAdvancementBlocking = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/programs/update-prep-classes");
};

const updateAcceptanceLetters = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/yoksis/service/update-acceptance-letters");
};

const copyScholarships = async (formData) => {
    return financeApi.post("/scholarships/copy", formData);
};

const copyGraduateScholarships = async (formData) => {
    return financeApi.post("/scholarships/copy-graduate", formData);
};

const oisStudentTransfer = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/admin/ois-student-transfer", formData);
};

const oisStudentCourseTransfer = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/admin/ois-student-course-transfer", formData);
};
const sapStudentCourseTransfer = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/admin/sap/migrate/studentcourses", formData);
};
const searchKpssByStaffNationalId = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/staffs/kps-job", formData);
};
const bulkRegistrationsDocumentDownload = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/student/programs/bulk-ebys-document-download", formData);
};
const migrateUndergraduateStudentData = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/programs/migrate-to-undergraduate-student-data");
};
const deleteStudentOversemestersAfterLeavingStudents = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/student/semesters/delete-after-leaving-semester-student-semesters", config)
};
const setPassiveCourseSections = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/sections/set-passive-without-any-student-course-sections");
};
const transferTolesApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get("/toles/applications/register-students");
};
const bulkSectionUpdate = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post("/sections/student-update-section-from-excel",data);
};

const copyCourseOutcomes = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/outcome/semesters/copy/${fromSemesterId}/${toSemesterId}`);
};

const copyProgramOutcomes = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/program/outcome/semesters/copy/${fromSemesterId}/${toSemesterId}`);
};
const courseOutcomesCopy = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/program/outcomes/copy/${fromSemesterId}/${toSemesterId}`);
};
const courseProgramOutcomesCopy = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/program/outcome/matrices/copy/${fromSemesterId}/${toSemesterId}`);
};
const courseAgreementSuspensionControl= async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/course/agreement/suspension-control');
};

const copyCourseDescriptions = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/descriptions/copy/${fromSemesterId}/${toSemesterId}`);
};

const copyWeeklyCoursePlans = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/weekly/course/plans/copy/${fromSemesterId}/${toSemesterId}`);
};

const copyCourseAssessments = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/assessments/copy/${fromSemesterId}/${toSemesterId}`);
};

const copyCourseWorkloads = async (fromSemesterId, toSemesterId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`/course/workloads/copy/${fromSemesterId}/${toSemesterId}`);
};

const assignSemesterStatusByYoksisMaxDuration = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/programs/assign-semester-status-by-yoksis-max-duration');
};

const turkishPrepClassAdvancement = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/programs/update-turkish-prep-classes');
}


export default {
    getAll,
    getMyLogs,
    get,
    download,
    downloadFailLog,
    calculateExtraGraduateCourses,
    autoCourseRegistration,
    autoRepeatCourseRegistration,
    autoIrregularCourseRegistration,
    createStudentSemesters,
    assignDoesntHavePaymentApproval,
    assignDoesntHaveCourseRegistration,
    prepStudentsSemesterStatusUpdate,
    bulkAddressUpdate,
    foreignStudentCommunityInternshipAssignment,
    registrationsBulkDelete,
    courseDropCommand,
    fileImport,
    studentExcelImport,
    bulkTranslationImport,
    updateSummerSchoolPaidStatus,
    studentProgramsGraduationRequirement,
    deleteEmptySummerStudentSemester,
    createSectionForRepeats,
    scholarshipsImport,
    registrationsImport,
    updateMaxDurationInformationStart,
    findPersonFromKpsByStudentNumbers,
    calculateNumberOfSemesters,
    osymScoreInquiry,
    preparatoryClassAdvancementBlocking,
    queryOsymPoints,
    updateAcceptanceLetters,
    copyScholarships,
    copyGraduateScholarships,
    oisStudentTransfer,
    oisStudentCourseTransfer,
    searchKpssByStaffNationalId,
    bulkRegistrationsDocumentDownload,
    migrateUndergraduateStudentData,
    deleteStudentOversemestersAfterLeavingStudents,
    setPassiveCourseSections,
    transferTolesApplication,
    bulkSectionUpdate,
    copyCourseOutcomes,
    copyProgramOutcomes,
    courseOutcomesCopy,
    courseProgramOutcomesCopy,
    sapStudentCourseTransfer,
    courseAgreementSuspensionControl,
    copyCourseDescriptions,
    copyWeeklyCoursePlans,
    copyCourseAssessments,
    copyCourseWorkloads,
    assignSemesterStatusByYoksisMaxDuration,
    turkishPrepClassAdvancement
};
